<template>
    <div class="px-3">
        <div class="row word-break" v-if="showShopDetails().masterId">
            <div class="col-lg-6">
                <h4>รหัสมาสเตอร์ :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>{{res.masterId}}</h4>
            </div>
        </div>
        <div class="row word-break" v-if="showShopDetails().dealerId">
            <div class="col-lg-6">
                <h4>รหัสตัวแทน :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>{{res.dealerId}}</h4>
            </div>
        </div>
        <div class="row word-break" v-if="showShopDetails().shopCode">
            <div class="col-lg-6">
                <h4>รหัสร้านค้า :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>{{res.code}}</h4>
            </div>
        </div>
        <div class="row word-break" v-if="showShopDetails().shopCode">
            <div class="col-lg-6">
            <h4>แพ็กเกจ :</h4>
            </div>
            <div class="col-lg-6 custom-text">
                <h4>{{res.package}}</h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "base-shop-details",
    data(){
        return {
            user : this.$USER_LOGIN.get()
        }
    },
    methods:{
        showShopDetails(){

            return {
                "dealerId": (
                    (
                        !this.user.isUnderByShippop ||
                        this.user.isSuperadmin
                    ) &&
                    !this.user.isShippop &&
                    !this.user.isMaster
                ),
                "shopCode": !this.user.isSuperadmin && !this.user.isMaster,
                "masterId": this.user.isMaster
            }
        }
    },
    computed: {
        res(){

            let logout = 'โปรดเข้าสู่ระบบใหม่'
            let res = {
                code : logout,
                package : logout,
                dealerId : logout,
                masterId : logout
            }
            if( this.user ){
                res.code = this.user.details.shop_code
                res.package = this.user.details.shop_package
                res.dealerId = this.user.details.dealer_id
                res.masterId = this.user.details.master_id
            }

            return res

        }
    }
}
</script>
<style scoped>
  .word-break {
    white-space: normal;
    word-break: break-word;
  }
  @media (min-width: 768px){
    .custom-text {
        text-align: right;
    }
}
</style>